export default __webpack_public_path__ + "static/media/video.a19de77e.png";